import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { RouterModule } from '@angular/router';
import { AddProductModalComponent } from '@app/modules/product-catalog/components/add-product/add-product-modal.component';
import { SharedModule } from '@app/shared/shared.module';
import { ProductCatalogProductsComponent } from './pages/product-catalog-products/product-catalog-products.component';
import { ProductDetailComponent } from './pages/product-detail/product-detail.component';
import { ProductCatalogRoutingModule } from './product-catalog-routing.module';

@NgModule({
  declarations: [ProductCatalogProductsComponent, ProductDetailComponent, AddProductModalComponent],
  imports: [
    CommonModule,
    SharedModule,
    ProductCatalogRoutingModule,
    RouterModule,
    FormsModule,
    MatMenuModule, // Added MatMenuModule
    MatButtonModule, // Added MatButtonModule
  ],
  providers: [],
})
export class ProductCatalogModule {}
